import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { MainleftpanelviewComponent } from './mainleftpanelview/mainleftpanelview.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { CommonComponentModule } from '../common/common.module';


@NgModule({
  exports: [MainleftpanelviewComponent],
  declarations: [MainleftpanelviewComponent],
  imports: [
    CommonModule,
    NgbModule,
    CommonComponentModule,
    SharedModule,
  ]
})

export class LeftpanelModule { }

// translation loader moved to SharedModule
